module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/metronomeClick-452db04a3c684f96cb7b18ea54765fd8.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/metronomeClick.mp3
// module id = 65
// module chunks = 0